<template>
<div>
    <div class="upload-box">
        <label v-if="!file?.id" for="media-file">
            <i class="icon-upload mr-2"></i>{{ __('form.upload') + ' '+ __('type.' + fileType) }}
            <FileSizeMaximum :fileType="fileType" />
        </label>
        <span>{{ form.file && form.file.name }}</span>
        <input
            type="file"
            name="media-file"
            id="media-file"
            class="hidden"
            @input="(e)=>form.file = e.target.files[0]"
        >

        <!-- Different files we are showing in different way -->
        <div v-if="isImage(file)" class="content">
            <img style="max-height: 180px; margin: 0 auto;" :src="isImage(file)">
        </div>
        <div v-if="isAudio(file)">
          <audio class="w-full" controls>
            <source :src="isAudio(file)" type="audio/mpeg">
          Your browser does not support the audio element.
          </audio>
        </div>
        <div v-if="isVideo(file)" class="overflow-hidden">
            <video width="400" controls>
                <source :src="isVideo(file)" type="video/mp4">
                Your browser does not support HTML video.
            </video>
        </div>
        <div v-if="is3dObject(file)" class="">
            <a :href="is3dObject(file)"><i class="icon-download mr-2"></i>Download</a>
        </div>
        <div v-if="isWaypoints(file)" class="">
            <div class="block">{{ makeName(file) }}</div>
            <a :href="isWaypoints(file)"><i class="icon-download mr-2"></i>Download</a>
        </div>
        <!-- Different files we are showing in different way -->

    </div>

    <div v-if="Object.values($page.props.errors).length > 0" class="block">
        <span v-for="error in Object.values($page.props.errors)" class="errormessage">{{ error }}</span>
    </div>

    <div class="overflow-y-auto max-h-96">
        <div class="mt-2">
            <label class="text-sm" for="file_type">Select file type</label>
            <div class="bg-gray-800 rounded-lg p-2 pt-4 pl-4">

                <MediaLibraryFileTypes
                    :object_type="file && file.object_type"
                    :fileType="fileType"
                    @update:fileType="updateObjectType"
                />

            </div>
        </div>

        <!-- Metadata information -->
        <div class="mt-2 overflow-y-auto">
            <MetaData :form="form"
                @update:copyrightText="newValue => form.copyright_text = newValue"
                @update:copyrightLink="newValue => form.copyright_link = newValue"
                @update:physicalWidth="newValue => form.physical_width = newValue"
                @update:color="newValue => form.color = newValue"
                @update:thresholdPercentage="newValue => form.threshold_percentage = newValue"
            />
        </div>
        <!---->
    </div>


    <div v-if="file" class="flex justify-between pt-2">
        <button class="btn btn-black" @click.prevent="$emit('upload:sidebar', false)">
            Close
        </button>

        <button @click="deleteFileModal" class="btn btn-black">Delete</button>

        <button class="btn btn-gradient" @click="() => confirmation_modal = true">
            <i class="save mr-1"></i>Save
        </button>
    </div>
    <div v-else class="flex justify-between pt-2">
        <button class="btn btn-black" @click.prevent="$emit('upload:sidebar', false)">
            Close
        </button>

        <button v-if="!form.processing" class="btn btn-gradient" @click="uploadFile">
            <i class="save mr-1"></i>{{ __('media.upload-file') }}
        </button>
        <button v-else class="btn btn-gradient"><Spinner/></button>
    </div>


</div>
    <ConfirmationModal
        :showModal="confirmation_modal"
        :hideModalFn="() => confirmation_modal = false"
        :form="form"
        :updateFile="updateFile"
    />
</template>

<script>
import MediaLibraryFileTypes from './MediaLibraryFileTypes';
import MetaData from './MetaData';
import Spinner from '@/UI/Spinner';
import ConfirmationModal from './ConfirmationModal';
import { __ } from '@/locale';
import FileSizeMaximum from '@/Pages/Media/FileSizeMaximum';

export default {
    components:{
        MediaLibraryFileTypes,
        MetaData,
        Spinner,
        ConfirmationModal,
        FileSizeMaximum,
    },
    emits: ['upload:sidebar'],
    props: ['file', 'updateMediaFiles', 'showModal', 'fileType'],
    data() {
        return {
            form: this.$inertia.form({
              _method: 'POST',
              tour_identifier: this.$page.props.tour && this.$page.props.tour.data.identifier,
              id: null,
              path: '',
              file: null,
              object_type: `file_meta_data_${this.fileType}`,
              copyright_text: '',
              copyright_link: '',
              physical_width: '',
              color: '',
              threshold_percentage: '',
            }),
            confirmation_modal: false,
            __,
        }
    },
    watch:{
        file: function(newState, oldState){
            this.updateFileForm(newState);
        },
        showModal: function(newState, oldState){
            if(newState == true) {
                this.updateFileForm(null)
            }
        },
        fileType: function(newState, oldState) {
        },
    },
    methods: {
        isImage(file){
          if(!file){
            return
          }
          const object_type = file.object_type;
          if(object_type == 'file_meta_data_image' || object_type == 'file_meta_data_panorama_image'
              || object_type == 'file_meta_data_marker'){
              return file.path.includes('http') ? file.path : file.path;
          }
          return false
        },
        isAudio(file){
          if(!file){
            return
          }
          const object_type = file.object_type;
          if(object_type == 'file_meta_data_audio'){
              return file.path.includes('http') ? file.path : '/'+file.path;
          }
          return false
        },
        isVideo(file){
          if(!file){
            return
          }
          const object_type = file.object_type;
          if(object_type == 'file_meta_data_chroma_video' || object_type == 'file_meta_data_panorama_video'
              || object_type == 'file_meta_data_video'){
              return file.path.includes('http') ? file.path : '/'+file.path;
          }
          return false
        },
        is3dObject(file){
          if(!file){
            return
          }
          const object_type = file.object_type;
          if(object_type == 'file_meta_data_three_dimensional_object'){
              return file.path.includes('http') ? file.path : '/'+file.path;
          }
          return false
        },
        isWaypoints(file){
          if(!file){
            return
          }
          const object_type = file.object_type;
          if(object_type == 'file_meta_data_waypoints'){
              return file.path.includes('http') ? file.path : '/'+file.path;
          }
          return false
        },
        makeName(file){
          if(!file){
            return
          }
          if(file.path.split('/').pop().includes('three'))
          {
              const arr = file.path.split('/');
              return arr[arr.length-2]+'.'+file.extension;
          } else {
              return file.path.split('/').pop();
          }
        },
        updateObjectType(newValue){
            if(newValue.includes('file_meta_data_three_dimensional_object')){
                this.form.object_type = 'file_meta_data_three_dimensional_object';
            } else {
                this.form.object_type = newValue;
            }
        },
        updateFileForm(newFileState){
            this.form.file = null;
            this.$page.props.errors = {};
            if(newFileState == null){
                this.form.id = null;
                this.form.path = '';
                this.form.tour_identifier = this.$page.props.tour.data.identifier;

                this.form.object_type = `file_meta_data_${this.fileType}`;
                this.form.copyright_text = '';
                this.form.copyright_link = '';
                this.form.physical_width = '';
                this.form.color = '';
                this.form.threshold_percentage = '';
            } else {
                this.form.id = newFileState.id;
                this.form.path = newFileState.path;
                this.form.object_type = newFileState.object_type;
                this.form.copyright_text = newFileState.copyright_text;
                this.form.copyright_link = newFileState.copyright_link;
                this.form.physical_width = newFileState.metaData.physical_width;
                this.form.color = newFileState.metaData.color;
                this.form.threshold_percentage = newFileState.metaData.threshold_percentage;
            }
        },
        updateFile() {
          this.form.put(route('media.update', this.form.id), {
              preserveScroll: true,
              onSuccess: () => {
                this.confirmation_modal = false;
              },
              onError: (err) => {
                console.log(err)
              },
          });
        },
        uploadFile() {
          this.form.post(route('media.upload', this.form.tour_identifier), {
              preserveScroll: true,
              onSuccess: () => {
                this.updateMediaFiles();
                this.updateFileForm(null);
              },
              onError: (err) => {},
          });
        },
        deleteFileModal(){
            alert('Are you sure that you want to delete the file?')
        }
    }
}
</script>
